import { IdwTable } from "../../../common/idw-table/idw-table";
import { resources } from "@constants/hardcoded-strings";
import { FormattedServiceOfferingTotal, FormattedWorkflowResultsDetailsResponse } from "@idw-types/data/workflow-results-details";
import { IdwTableContainer } from "../../../common/idw-table-container/idw-table-container";
import { createColumnHelper, getCoreRowModel, useReactTable } from "@tanstack/react-table";
import { useMemo } from "react";

type ServiceOfferingTransactionsSummaryTableContainerProps = {
    workflowResultsDetails: FormattedWorkflowResultsDetailsResponse;
};

export const ServiceOfferingTransactionsSummaryTableContainer = (props: ServiceOfferingTransactionsSummaryTableContainerProps) => {
    const { workflowResultsDetails } = props;

    const columnHelper = createColumnHelper<FormattedServiceOfferingTotal>();
    const columns = useMemo(() => ([
        columnHelper.accessor("serviceOffering.name", {
            header: resources.tables.serviceOfferingTransactionsSummary.columns.serviceOffering.header
        }),
        columnHelper.accessor("totalTransactionCount", {
            header: resources.tables.serviceOfferingTransactionsSummary.columns.totalTransactions.header
        })
    ]), [workflowResultsDetails]);

    const useTableResult = useReactTable({
        columns,
        data: workflowResultsDetails.summary.serviceOfferingTotals,
        filterFns: null,
        sortDescFirst: false,
        getCoreRowModel: getCoreRowModel()
    });

    return (
        <IdwTableContainer>
            <IdwTable
                id="service-offering-transactions-summary"
                useTableResult={useTableResult}
                headerColumnKeyPrefix={"service-offering-transactions-summary"}
            />
        </IdwTableContainer>
    );
};